/**
 * Validator for `path_PathGroupUpdateResource`.
 * Required (per Swagger): active, conditions, paths.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { validateConditionsBag } from '../conditions';
import {
  describe,
  isPlainObject,
  joinPath,
  pushError,
  requireBoolean,
  type ValidationCtx,
} from '../primitives';
import { validatePathUpdate } from './path';

export function validatePathGroupUpdate(
  ctx: ValidationCtx,
  v: unknown,
  basePath: string,
): void {
  if (!isPlainObject(v)) {
    pushError(ctx, basePath, 'invalid_object', 'Expected group object');
    return;
  }
  requireBoolean(ctx, v, 'active', basePath);

  const conditionsPath = joinPath(basePath, 'conditions');
  if (v.conditions === undefined) {
    pushError(
      ctx,
      conditionsPath,
      'missing_required',
      'Missing required field "conditions"',
    );
  } else {
    validateConditionsBag(ctx, v.conditions, conditionsPath);
  }

  const pathsPath = joinPath(basePath, 'paths');
  if (v.paths === undefined) {
    pushError(
      ctx,
      pathsPath,
      'missing_required',
      'Missing required field "paths"',
    );
  } else if (!Array.isArray(v.paths)) {
    pushError(ctx, pathsPath, 'invalid_array', 'Expected array', {
      expected: 'array',
      received: describe(v.paths),
    });
  } else {
    v.paths.forEach((p, idx) => {
      validatePathUpdate(ctx, p, joinPath(pathsPath, idx));
    });
  }

  if (v.id !== undefined && typeof v.id !== 'string') {
    pushError(ctx, joinPath(basePath, 'id'), 'wrong_type', 'Expected string');
  }
  if (v.name !== undefined && typeof v.name !== 'string') {
    pushError(ctx, joinPath(basePath, 'name'), 'wrong_type', 'Expected string');
  }
  if (v.smartRotation !== undefined && typeof v.smartRotation !== 'boolean') {
    pushError(
      ctx,
      joinPath(basePath, 'smartRotation'),
      'wrong_type',
      'Expected boolean',
    );
  }
}
